/**
 * @generated SignedSource<<3ca20ea147597d0213340a17dd6efa60>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ProductMembershipStatus = "enrolled" | "unenrolled" | "%future added value";
export type UnenrollProductMemberInput = {
  productMembershipId: string;
};
export type LeaveProductButtonMutation$variables = {
  input: UnenrollProductMemberInput;
};
export type LeaveProductButtonMutation$data = {
  readonly response: {
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
    readonly productMembership: {
      readonly id: string;
      readonly status: ProductMembershipStatus;
    } | null;
  };
};
export type LeaveProductButtonMutation = {
  response: LeaveProductButtonMutation$data;
  variables: LeaveProductButtonMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": "response",
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UnenrollProductMemberResponse",
    "kind": "LinkedField",
    "name": "unenrollProductMember",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ProductMembership",
        "kind": "LinkedField",
        "name": "productMembership",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LeaveProductButtonMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LeaveProductButtonMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "fd25fedb2ce65b54e6842a4d92dbb03c",
    "id": null,
    "metadata": {},
    "name": "LeaveProductButtonMutation",
    "operationKind": "mutation",
    "text": "mutation LeaveProductButtonMutation(\n  $input: UnenrollProductMemberInput!\n) {\n  response: unenrollProductMember(input: $input) {\n    productMembership {\n      id\n      status\n    }\n    errors {\n      field\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a2e8fecebc7b1b8f93bef7a510e2e471";

export default node;
